import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isAsyncValueProvider } from '../../../../models/async-value';
import { AbstractField } from '../../models/field-configs/abstract-field';
import { FieldLabelConfig } from '../../models/field-configs/field-label-config.interface';
import { select, Store } from '@ngrx/store';
import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';
import { getActiveExperienceCode } from '@ordersnproducts/modules/order-builder/reducers';
import { RepeatOrderState } from '@ordersnproducts/modules/new-repeat-order/reducers';

@Component({
  selector: 'app-form-info-icon-message',
  templateUrl: './form-info-icon-message.component.html',
  styleUrls: ['./form-info-icon-message.component.scss'],
})
export class FormInfoIconMessageComponent extends AbstractField implements OnInit, OnDestroy {
  private _ngDestroyed$ = new Subject();

  // Config
  public config: FieldLabelConfig;
  public group: UntypedFormGroup;

  // View
  public text: string;

  public infoisVisible = true;

  constructor(private store: Store<RepeatOrderState>) {
    super();
  }

  ngOnInit() {
    // Set text value
    if (this.config.text) {
      if (isAsyncValueProvider(this.config.text)) {
        this.config.text
          .getValue()
          .pipe(takeUntil(this._ngDestroyed$))
          .subscribe((text) => (this.text = text));
      } else if (typeof this.config.text === 'string') {
        this.text = this.config.text;
      }
      this.getExperiences();
    }
  }

  ngOnDestroy(): void {
    this._ngDestroyed$.next();
    this._ngDestroyed$.complete();
  }

  private getExperiences() {
    this.store.pipe(select(getActiveExperienceCode), takeUntil(this._ngDestroyed$)).subscribe((experienceCode) => {
      if (experienceCode === ORDER_EXPERIENCES.SIMMA_UNIVERSAL_LINK) {
        this.infoisVisible = false;
      }
    });
  }
}
